import { Component, Input } from '@angular/core';

@Component({
  selector: 'q-avatar',
  templateUrl: './avatar.component.html'
})

export class AvatarComponent {

  // #region Directives
  @Input() name: string;
  @Input() size: number;
  // #endregion

  public Initial(name: string, size: number): string {
    size = size || 60;
    if (name === undefined) {
      name = '?';
    }
    const nameSplit: Array<string> = name.toUpperCase().split(' ');
    const colour: Array<string> = [
      '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9', '#8e44ad', '#2c3e50',
      '#f1c40f', '#e67e22', '#e74c3c', '#ecf0f1', '#95a5a6', '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d'
    ];

    let initials: string;
    if (nameSplit.length === 1) {
      initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
    } else {
      initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
    }

    const colourIndex: number = (initials.charCodeAt(0) - 65) % 20;
    const canvas: HTMLCanvasElement = document.createElement('canvas');

    const context: any = canvas.getContext('2d');

    canvas.width = size;
    canvas.height = size;

    context.fillStyle = colour[colourIndex];
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.font = `${Math.round(canvas.width / 2)}px Arial`;
    context.textAlign = 'center';
    context.fillStyle = '#FFF';
    context.fillText(initials, size / 2, size / 1.5);

    return canvas.toDataURL();
  }
}
